export const LABOR_ALLOCATION_MODE = {
    FIXED: 'FIXED',
    VARIABLE: 'VARIABLE',
    FLOOR: 'FLOOR'
};
export const JOB_TITLE_TYPES = {
    REGULAR: 'REGULAR',
    SPECIAL: 'SPECIAL',
};